module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CHAPTER ONE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("“A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NYONE HEAR FROM")]), _vm._v(" E"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LISE")])]), _vm._v("?” Joe Bennett walked into the lunchroom at the back of the suite of offices he and his partner—and the bank—now owned. Eating meals ranging from fruit and yogurt to homemade burgers, the employees Elise Richardson supervised sat at the long, elegant wooden table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not a word.” Twenty-five-year-old Angela Parks glanced over her shoulder at him from the granite-topped island marking the center of the full kitchen on one end of the room. She was making a salad.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was Thursday. On Fridays Elise cooked lunch for their nine-member staff. Maybe she was out grocery shopping for the next day’s offering.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But it would be the first time in the ten years they’d been in business that she’d done so during the workday. At night, while Joe left the job and lived a life, Elise worked at home—or shopped for the office.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She didn’t say where she was going?”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think she had a dentist appointment,” Ruth Gregory said, straightening a stem in the silk flower centerpiece in front of her. At fifty, she was the oldest B&R employee.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.” Thirty-five-year-old Mark Oppenheimer popped the last of his usual peanut butter sandwich in his mouth and stood. “That was last month. Today she didn’t say what kind of appointment, only that she shouldn’t be gone more than an hour.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What time was that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nine.” As their chief financial officer, the skinny, bespectacled man was Elise’s second in command and the source most likely to be up to date.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Glancing at his multi-dialed designer watch—which his then-wife had bought him for Christmas a few years ago and which Joe wore because it would be a waste not to, even though he preferred the simple large-faced cheap number he’d worn in college—he frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That was almost four hours ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mark wiped the crumbs he’d left on the table onto the floor—a man after his own heart. “I know,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And she hasn’t called?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After another few seconds of standing there blankly, Joe started to leave. And then turned back.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("“Anyone think to call the hospitals to make sure she wasn’t in an accident?” He was only half ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("joking, but their chuckles followed him down the hallway.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve got lunch with Anderson, Anderson and Bailey,” he told his secretary on his way out. The law firm was the biggest in the state of Michigan—a six-million-dollar account—and B&R had been courting them for a couple of years. “Text message me the second Elise gets in, will you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bennett and Richardson Professional Employee Organization, or B&R PEO, offered companies a comprehensive package that included payroll, workers’ compensation, tax compliance and group insurance, all at a rate lower than they could arrange for themselves. Joe Bennett was in charge of sales, and Elise Richardson, his best friend from college, oversaw virtually everything else.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Normally his cell phone was in the Off position when he was in meetings—commonly disguised as social gatherings now that he had two salesmen who made the office calls to sit with managers and work out logistics. Today he turned his cell on to Vibrate instead, so he’d know if and when a message came through. He didn’t have an urgent need to speak to his business partner. He just wanted to assure himself that she was going to be around at some point to nag him about something.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE LONG")]), _vm._v(", "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("FAMILIAR")]), _vm._v(" private road across the front of the cemetery was potholed and narrow, barely wide enough to fit the Corvette. Elise passed ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("several lanes that sectioned off areas filled with headstones of varying sizes, many with urns bearing colorful floral arrangements planted on Memorial Day two and a half weeks before. As she rounded the back border of the carefully tended green acreage, she slowed to a stop, then climbed out of the car, wrapping her short, three-quarter-sleeved white sweater more closely around her.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d thought this stage of her life was about moving on. Becoming.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yet it turned out, at the moment, she needed her family.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Concentrating on the feel of the soft, cool grass, Elise walked barefoot toward the stone bearing her family name. It brought a happy memory of running through the grass in bare feet, chasing her older brother—because if she could catch him, he’d let her ride on the back of his bike to go for an ice cream cone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Back then, she’d thought that she’d always managed to catch him because she was so strong and fast. Now she understood that he’d allowed her to. And she smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hi,” she said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Tucking her calf-length, white-and-pink floral cotton skirt beneath her, she sat directly in front of the main stone marked Richardson. And didn’t know what else to say. Normally her visits were to take care of their gravesites—pull weeds, plant flowers, scrub their stones. And while she worked, she’d tell them ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("about the business, something that happened with an employee or a new building in town—not that they’d ever even heard of Lowell, Michigan.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d bought the plot and buried what was left of their ashes, brought with her from Arkansas, as part of her therapy about eight years before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mama?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her voice broke when she heard the word come out of her mouth. So she turned to another of the individual stones, bearing first and middle names, birth and death dates. “Daddy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It wasn’t any easier. Her gaze moved again. “Danny?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And again. “Ellen?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Baby Grace?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There’d been four of them once. Four children filling her parents’ home and hearts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now there was only her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mama?” She cried openly because she couldn’t help it, and because there was no one around to see. Wiping her eyes with the bottom edge of her skirt, she finally admitted, “I’m scared.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Complete silence followed the confession. Inside of her and out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m scared, Mama,” she said again, more firmly. “I know I’m not supposed to be, that I’m a survivor, but sometimes I wish I’d died along with the rest of you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("She quieted, waited to be struck for the ungrate")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("ful thought. But nothing happened. She wasn’t punished. And the thought didn’t leave, either.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why did I have to be the one they got? Why did my bedroom have to be on the farthest side of the house? Why did Ellen share a room with Grace and not me? Why only me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Because you’re special.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The words were a whisper in her mind, almost as though carried on the light breeze. They were a memory from her early childhood. And from the physically and emotionally agonizing months and years that stretched from her eleventh year to her twentieth. She’d lost track of the number of people who’d said the words to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she could still hear them in her mother’s voice the day she’d asked her why she couldn’t have been the oldest like Danny, or the first girl like Ellen, or the baby like Grace. She’d been searching for her place, even then, stuck in the middle with no solid sense of how she fit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stared at the smaller stone bearing her mother’s name. Wanting. Wishing. Needing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m pregnant, Mama.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The stone in front of her blurred again. Pulling her knees up, her arms wrapped around them, Elise sat still and let her life settle around her as it would. And as the tears continued to flow, she lifted the edge of her skirt a second time, wiping her face. A face that none of the people whose names were engraved on those small, cold stones would ever recognize.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OE WASN’T SURE")]), _vm._v(" what to think when, at five after six that Thursday evening in mid-June, he walked up the steps of his partner’s elegant, colonial-style home on Lakeshore Drive overlooking the Flat River and knocked on the door. She pulled it open, looking as normal and fine as she did any other day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re okay.” He hadn’t meant to sound disappointed. Hell, he wasn’t! He was relieved as hell. But—")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You haven’t missed a day of work since we opened shop ten years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then I guess I was due.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You didn’t call.” Sweating in his short-sleeved shirt and tie, although the evening was a balmy seventy degrees, Joe shifted from foot to foot.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I own the company, Joe. I don’t have to call.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was right, of course. “Co-own.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How many times have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" missed coming into the office and not called in about it?” Her chin lifted a notch, her dark, short, sassy hair falling away from her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was different for him. He made outside calls. And even when he took a day off… “I take my cell phone everywhere. You can always reach me if there’s an emergency.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I had mine, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You didn’t answer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I listened to the messages.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Then she realized he’d been checking to make ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("sure she was okay. And she hadn’t bothered to call him back, to assure him that she was.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Odd.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can I come in?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hesitated and then nodded, stepping away from the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He followed her through the formal living room, dining room and kitchen to the family room in the back of the house. He’d never understood why a woman who lived alone wanted so much space around her, but then, he’d never understood Elise, period.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Outside the office, that was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A half-filled and perspiring glass of what appeared to be mostly juice and melted ice sat on the end table. The lamp was on. The large-screen television in front of the creamy white leather sofa was silent. There were no books, remote controls, or papers to indicate that his partner had been doing anything while she’d been sitting there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tucking her feet beneath her white skirt, she curled up on the sofa. And picked at her fingernails.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her cats, Darin and Samantha, settled behind her on the back of the sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You mind if I get myself a bottle of water?” He wasn’t thirsty. Except, perhaps, for a shot of bourbon. Straight up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hadn’t consumed alcohol straight up since college.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("“Of course not.” Her smoky gray eyes were ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("more mysterious to him than usual as she glanced at him. Why did the woman’s expression so rarely show him what she was thinking, like everyone else’s did? “Help yourself.”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Retrieving a bottle from the top shelf of the refrigerator, he glanced around the kitchen. The red-and-gold-flowered canisters that matched the wall paper border topping the golden accent wall were all neatly in place. Salt and pepper shakers that went with the set were on the stove where he’d always seen them in the past. If she’d eaten anything, she’d already cleaned up. And dried the sink, as well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d had Kelly and him for dinner on a regular basis when they’d still been married. Joe couldn’t remember her ever drying out the sink when she’d finished the dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hadn’t she eaten?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So what’d you do today?” He tried for casual as he approached her again, unsure whether he should join her on the couch or remain standing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now her eyes were moist when she looked at him, as though, while he’d been perusing her kitchen, she’d been crying. Or was about to start.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was new ground for him. In the almost fourteen years they’d known each other it had somehow always been "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _vm._v(" picking up the pieces for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him.")]), _vm._v(" He stared at the polished gleam on his wing-tip shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mostly I stayed home.”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe thought about the times "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he’d")]), _vm._v(" taken off work—they weren’t as rare as hers, but rare enough that the hours were filled to the brim.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mostly?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elise’s smile settled his nerves some. “It’s okay, Joe. You can go. I’m fine. Really.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wanted to go.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You sure you’re okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded. Darin opened one eye and closed it again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe drank the bottle of water, recapped it, planning to throw it in the trash in the kitchen on his way out. He had a frozen Salisbury steak and mashed potato dinner to get home to. And then was meeting a couple of bankers for drinks at nine, after their racquetball game. If all went well, he’d be signing on their chain of financial institutions, Michigan Local Banks, to begin payroll at the beginning of July. It was a ten-million-dollar account—a hundred-thousand-dollar-a-year payout to B&R—his largest yet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe glanced at his partner, the woman who’d been his buddy in college, challenging his thinking at every turn, challenging him to put his money where his mouth was and go into business, intimidating the hell out of him a time or two, listening to him whine and then curse when Kelly left him to make babies with a man who wanted them. She’d gotten drunk with him the day his divorce papers came through.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t go until you tell me what’s going on.”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That perfectly sculpted chin lifted again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m six-and-a-half weeks pregnant.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe dropped his water bottle.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WON’T LET")]), _vm._v(" the business suffer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shocked at the emotions running through him—anger at the man who’d done this to her, feelings of protectiveness—Joe loosened his tie and sat. Darin and Samantha both leaped from the sofa and scurried out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The idea of Elise pregnant was so far removed from his idea of reality he couldn’t quite get his mind around it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“B&R didn’t even enter my head.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, it will, and I want you to know that I’m prepared to do whatever it takes to handle my responsibilities the same as I always have.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t doubt her. And at the moment didn’t care.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Looking her in the eye, he sought to explain the inexplicable. “Who’s the father?” And why did he already hate the guy so much?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fire burned beneath his skin. How did a woman—at least the kind of woman Elise was—get pregnant without knowing the father? Unless she’d been raped. Could a woman go through something like that and never let on? Surely even Elise, as strong and unflappable and self-contained as she was, couldn’t do that.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("And how did he tackle such a sensitive and ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("intimate subject? He didn’t want to trigger a breakdown.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He thought of the times he’d seen her cry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There weren’t any.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The times she’d come to him with a personal problem.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There weren’t any of those, either.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When are you due?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Christmas.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He couldn’t help a quick glance at her midsection. It was as flat as ever.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I won’t let you and the business down, Joe,” she repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not worried about me! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Or")]), _vm._v(" the business.” Did she think he was that shallow?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re obviously upset.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d like to kill the bastard who did this to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" did this to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Had her expression not been so earnest, the situation so tragic, he would have chuckled. “My friend, you are the most self-sufficient woman I’ve ever met, but even you cannot produce the necessary male ingredient for procreation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, but I can buy it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her skirt had pink flowers on it. And dark smudges along the hem. He waited.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I had artificial insemination.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You meant to get pregnant?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah.”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good God, woman! What the hell did you do that for?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I want a family, Joe!” Her brows rose with her voice, giving her an air of desperation. Panic. He had no idea what to do.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head. “Don’t ‘but’ me right now, okay? This isn’t up for debate. It’s a done deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m trying to understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How could you?” Elise got up and left the room so quickly, he was pretty sure she wasn’t coming back. And wished there were a door that would allow him to quietly slip away without having to pass through the inner domain of her home. He wished she had a best friend he could call to take over where he was grossly inadequate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here.” She was back. With a shot of bourbon mixed with water.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe accepted the gift without a word. Took a long sip. And stared at ice cubes floating in amber-colored liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sitting down on the other end of the couch, Elise leaned forward, her elbows on her knees, and turned her head toward him. “How many guys have I dated more than once in the last five years?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Two that I know of.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then you know of all of them.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("He was treading on uncharted ground. He’d been confiding in her about his love life for most ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("of the time he’d known her. All he knew of hers was what they’d just covered.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re a strikingly beautiful woman, Elise.” Surely she knew that. “You could have any man you wanted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still she watched him. “I didn’t think you ever noticed I’m a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The glass started to slide through Joe’s sweaty fingers. He got a better grip.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I noticed. But you made it plain from the beginning that you valued our friendship and wanted it to stay that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I did. I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I respected that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Staring at her clasped hands, she was silent for a long moment. “I have a little story to tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He waited.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“One I should’ve told you years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why didn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not sure,” she said, frowning as she peered over at him again. “My reasons seem silly now, and yet to me they make perfect sense.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("He had no idea what any of this had to do with her newly disclosed pregnancy, but knowing Elise, he was certain he was going to find out. What surprised him was how badly everything about this evening threatened him. He was generally a flexible guy. Took change on the cuff. Accepted other people and their choices, whether like his or not, without much difficulty. He’d grown up in a ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("family with seven kids, and someone was always doing something he didn’t like. To survive, he’d learned the wisdom of withholding judgment.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You mentioned my looks just now, as though my being beautiful was just part of who I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Isn’t it?” Joe asked her. She used to intrigue and frustrate him with her insights. He hadn’t realized she’d stopped sharing them until this moment when he realized that one was on its way. He sat back, waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d missed them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. My looks aren’t me at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We all have outer packaging,” he countered. A philosophical debate he could do. And even if he couldn’t, he was willing to try—anything to delay the moment they’d have to get back to the problem at hand. “It’s a part of you, just like your gender. And your sense of humor. It shapes many of life’s experiences and has no bearing on others.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Exactly, it’s a package. One we’re born with. It gives us a sense of self from our earliest moments.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t usually agree so quickly. “Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It combines with our memories, our loved ones, to provide the rock upon which our lives are built. No matter what happens to us, we can go back to that rock and find solid ground.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Uh-huh.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe watched her through narrowed eyes. There was a catch here. He could feel it coming.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And that’s why I didn’t tell you my little story before now,” Elise said. “I didn’t want you to know I don’t have that rock. You treated me like I was normal, and normal was something I hadn’t felt in far too many years.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Too many years,” Joe repeated. “You sound as if you were forty when I met you.” He wondered if pregnancy had already gotten to her emotions. One second she was Elise, and the next she wasn’t making any sense at all. “You weren’t even eighteen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you treated me like it. You wouldn’t have if I’d told you what I’d already endured before I got to my freshman year at the University of Michigan.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The room was warm. Joe chugged the last of his drink.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not the woman you see, Joe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t believe her.")])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page22"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ca954c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/merrychristmasbabies_ch01.vue
// module id = 78
// module chunks = 0